import { Client } from '@common/enums';
import { CLIENT_ENV } from '@constants/env';

export const QUESTION_QUERY_MIN_LENGTH = 2;
export const TOPICS_DROPDOWN_SELECTOR_MIN = CLIENT_ENV === Client.Hexal ? 10 : 5;
